import { observer } from "mobx-react";
import { IAppliedFilterChipComponent } from "../BaseChipComponents/IAppliedFilterChipComponent";
import {
    chipAggregatedLabel,
    chipItemLabel,
    renderCollectionChips,
    useChipFiltersStore,
} from "../BaseChipComponents/chipUtils";

export const PrimaryTopicsChip = observer(function (
    props: IAppliedFilterChipComponent,
) {
    const applicationFiltersStore = useChipFiltersStore(props);

    const topics = applicationFiltersStore.primaryTopics;
    const isExclusion = !applicationFiltersStore.containsPrimaryTopics;
    const setPrimaryTopicsAndNormalizeMode = (nextTopics: typeof topics) => {
        applicationFiltersStore.setPrimaryTopics(nextTopics);
        if (isExclusion && nextTopics.length === 0)
            applicationFiltersStore.setContainsPrimaryTopics(true);
    };

    return renderCollectionChips({
        items: topics,
        disabled: props.disabled,
        isApplicable: props.isApplicable,
        getKey: (topic) => topic.topicNumber,
        getLabel: (topic) =>
            chipItemLabel("Topic", topic.topicLabel, isExclusion),
        getTooltipLabel: (topic) => topic.topicLabel,
        getAggregatedLabel: (count) =>
            chipAggregatedLabel(count, "Topics", isExclusion),
        onRemoveAll: () => setPrimaryTopicsAndNormalizeMode([]),
        onRemoveItem: (topic) =>
            setPrimaryTopicsAndNormalizeMode(
                applicationFiltersStore.primaryTopics.filter(
                    (t) => t.topicNumber !== topic.topicNumber,
                ),
            ),
    });
});
